<template>
  <section class="social_section">
    <div class="row">
      <div class="col-12">
        <h5> <span class="border_bottom"> GM SOCIAL Hub</span></h5>
      </div>
    </div>

    <!-- social links -->
    <div class="row">
      <div class="col-12">
        <div class="social_link_wrapper">
          <div class="socialPlaterom">
            <a href="https://twitter.com/gmnanashi" target="_blank"><img src="@/assets/images/Twitter-Logo-2010.svg"
                alt="Twitter-Logo-2010.svg"></a>
          </div>
          <div class="socialPlaterom">
            <a href="https://www.instagram.com/gmnanashi/" target="_blank"><img src="@/assets/images/Instagram.svg"
                alt="Instagram.svg"></a>
          </div>
          <div class="socialPlaterom">
            <a href="https://www.facebook.com/GMNanashi/" target="_blank"><img src="@/assets/images/facebook_logo.svg"
                alt="facebook_logo.svg"></a>
          </div>
          <div class="socialPlaterom">
            <a href="https://www.patreon.com/gmnanashi" target="_blank"><img src="@/assets/images/petreon_logo.svg"
                alt="petreon_logo.svg"></a>
          </div>
          <div class="socialPlaterom">
            <a href="https://discord.gg/gVfrDSV" target="_blank"><img src="@/assets/images/discord.svg"
                alt="discord.svg"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SocialLinks',
  data () {
    return {}
  },
  mounted () {}

}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SocialLinks.vue